import React, { useState } from 'react';
import { Form, Input, Select, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { FormPageLayout } from '../../components/FormPageLayout';
import { useAutoSave } from '../../hooks/useAutoSave';

const { Option } = Select;

const ListingCheckItemEdit: React.FC = () => {
    const { skuId, id } = useParams<{ skuId: string; id: string }>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isNew = !id || id === 'new';

    const { triggerSave, state: saveState } = useAutoSave<any>({
        onSave: async (data) => {
            message.success(isNew ? '检查项已创建' : '已保存');
            if (isNew) {
                navigate(`/operation-strategy/${skuId}`);
            }
        },
        delay: 1000,
        enabled: !isNew,
        showMessage: true
    });

    const handleValuesChange = (_: any, allValues: any) => {
        if (!isNew) {
            triggerSave(allValues);
        }
    };

    const handleManualSave = async () => {
        try {
            const values = await form.validateFields();
            message.success('检查项已创建');
            navigate(`/operation-strategy/${skuId}`);
        } catch (error) {
            // Validation error
        }
    };

    const getSaveStatus = () => {
        if (saveState.isSaving) return 'saving';
        if (saveState.hasUnsavedChanges) return 'hasChanges';
        if (saveState.lastSavedAt) return 'saved';
        return 'idle';
    };

    return (
        <FormPageLayout
            title={isNew ? '添加自定义检查项' : '编辑检查项'}
            breadcrumbs={[
                { title: '运营策略', path: '/operation-strategy' },
                { title: 'SKU', path: `/operation-strategy/${skuId}` },
                { title: isNew ? '添加检查项' : '编辑检查项' }
            ]}
            saveStatus={getSaveStatus()}
            showSaveButton={isNew}
            onSave={handleManualSave}
            saving={loading}
        >
            <Form form={form} layout="vertical" onValuesChange={handleValuesChange} initialValues={{ value_type: 'bool' }}>
                <Form.Item name="name" label="检查项名称" rules={[{ required: true }]}>
                    <Input placeholder="例如: 是否有圣诞节促销图" />
                </Form.Item>
                <Form.Item name="category" label="分类" rules={[{ required: true }]}>
                    <Select>
                        <Option value="media">视觉/媒体</Option>
                        <Option value="text">文案/内容</Option>
                        <Option value="price">价格/促销</Option>
                        <Option value="social">评论/口碑</Option>
                        <Option value="traffic">流量/转化</Option>
                        <Option value="other">其他</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="value_type" label="值类型">
                    <Select>
                        <Option value="bool">是/否 (Yes/No)</Option>
                        <Option value="text">文本 (Text)</Option>
                        <Option value="number">数值 (Number)</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="description" label="判断标准/描述">
                    <Input.TextArea rows={3} placeholder="描述判断的具体标准..." />
                </Form.Item>
            </Form>
        </FormPageLayout>
    );
};

export default ListingCheckItemEdit;
